<template>
  <div :class="['flippable-card', { flipping: isFlipped }]" @click="onCardClick">
    <div class="card-front">
      <slot name="card-front"></slot>
    </div>
    <div class="card-back">
      <slot name="card-back"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isFlipped: Boolean,
    callback: Function,
    card: Object
  },

  methods: {
    onCardClick(event) {
      if (this.callback) {
        this.callback(this.card, event);
      }
    }
  }
};
</script>

<style lang="scss">
.flippable-card,
.flippable-card .card-back,
.flippable-card .card-front {
  overflow: hidden;
}

.flippable-card {
  top: 0;
  left: 0;
  position: relative;
  perspective: 600px;
}

.flippable-card .card-back {
  z-index: 9;
  position: relative;
  transform: rotateX(0deg) rotateY(0deg);
  transform-style: preserve-3d;
  backface-visibility: hidden;
  transition: all .5s ease-in-out;
}

.flippable-card.flipping .card-back {
  z-index: 9;
  transform: rotateY(-180deg);
}

.flippable-card .card-front {
  top: 0;
  left: 0;
  z-index: 8;
  position: absolute;
  overflow: hidden;
  text-align: center;

  transform: rotateY(180deg);
  transform-style: preserve-3d;
  backface-visibility: hidden;;
  transition:all .5s ease-in-out;
}

.flippable-card.flipping .card-front {
  z-index: 10;
  transform: rotateX(0deg) rotateY(0deg);
}
</style>
